import { render, staticRenderFns } from "./sendOrder.vue?vue&type=template&id=336d5012&scoped=true&"
import script from "./sendOrder.vue?vue&type=script&lang=js&"
export * from "./sendOrder.vue?vue&type=script&lang=js&"
import style0 from "./sendOrder.vue?vue&type=style&index=0&id=336d5012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d5012",
  null
  
)

export default component.exports